module.exports = __webpack_public_path__ + "img/c_1.91cd61ef.png";